module.exports = __webpack_public_path__ + "img/demo-remote-1.75a9c623.png";